export default __webpack_public_path__ + "static/media/team2.33c13398.jpg";